import { afterNextRender, Component, inject, input, model } from "@angular/core";
import { toObservable } from "@angular/core/rxjs-interop";
import { BaseConfig } from "../common/config/config.adapter";
import { PageInfo } from "../common/types";
import { DataGridStore } from "./data-grid.store";
import { ColumnDefinition } from "./types/colum-definition.type";
import { GridOptions } from "./types/grid.type";

@Component({
    template: ``,
    standalone: true,
})
export abstract class DataGridAdapter extends BaseConfig {
    rowData = input<any[]>([]);
    rowData$ = toObservable(this.rowData);
    columns = input<ColumnDefinition[]>([]);
    options = input<GridOptions>();
    options$ = toObservable(this.options);
    selecteds = model<any[]>([]);

    pageInfo = model<PageInfo | null>(null);

    readonly store = inject(DataGridStore);

    constructor() {
        super();

        this.options$.subscribe(() => {
            this.setCheckboxField();
            this.selecteds.set([]);
            this.store.init({
                options: this.options()!,
                columns: this.columns() || [],
                rowData: this.rowData() || [],
            });
        });

        afterNextRender(() => {
            this.rowData$.subscribe(() => {
                this.handleRowDataChange();
            });
        });
    }

    handleRowDataChange() {
        const rowData = this.rowData();
        const columns = this.columns();
        const options = this.options() || null;

        this.setCheckboxField();
        this.setRowNumberField();

        rowData?.map((row, index) => {
            if (!row["uniqueId"]) {
                row["uniqueId"] = index + 1;
            }

            // table 모드일 경우
            if (options?.view === "table") {
                const pageInfo = this.pageInfo();

                // rowNumber, checkbox 옵션 설정
                if (options?.rowNumber || !row["rowNumber"]) {
                    // pageInfo 여부에 따라 rowNumber 설정
                    if (!pageInfo) {
                        row["rowNumber"] = index + 1;
                    } else {
                        row["rowNumber"] = Math.max(
                            1,
                            (pageInfo?.totalItems || 0) -
                                (pageInfo?.pageSize || 0) * ((pageInfo?.pageNo || 0) - 1) -
                                index,
                        );
                    }
                }

                if (options?.checkbox || !row["checkbox"]) {
                    row["checkbox"] = false;
                }
            }
        });

        /**
         * @description checkbox, rowNumber 필드는 항상 앞에 위치하도록 설정합니다.
         */
        columns.sort((a, b) => {
            if (a.field === "checkbox") return -1;
            if (b.field === "checkbox") return 1;

            if (a.field === "rowNumber") return -1;
            if (b.field === "rowNumber") return 1;

            return 1;
        });

        this.store.init({
            rowData,
            columns,
            options,
        });
    }

    /**
     * checkbox 필드 설정
     */
    setCheckboxField() {
        const columns = this.columns();
        const options = this.options() || null;
        if (options?.view === "table" && options?.checkbox) {
            const found = columns.find((column) => column.field === "checkbox");
            if (!found) {
                columns.unshift({
                    field: "checkbox",
                    type: "checkbox",
                    name: "",
                });
            }
        } else {
            const index = columns.findIndex((column) => column.field === "checkbox");
            if (index > -1) {
                columns.splice(index, 1);
            }
        }
    }

    /**
     * rowNumber 필드 설정
     */
    setRowNumberField() {
        const columns = this.columns();
        const options = this.options() || null;

        if (options?.view === "table" && options?.rowNumber) {
            const found = columns.find((column) => column.field === "rowNumber");

            if (!found) {
                columns.unshift({
                    field: "rowNumber",
                    type: "number",
                    name: "순번",
                });
            }
        }
    }
}
